<!-- @format -->

<ng-container *transloco="let t">
  <div class="container sis-pt-md">
    <sis-page-title [title]="t('OPEN_UNIVERSITY.STUDIES_ACTIVATE_ERROR.TITLE')" />
    <div>
      <transloco key="OPEN_UNIVERSITY.STUDIES_ACTIVATE_ERROR.DESCRIPTION" />
      @if (!contactLinkObject) {
        <span>.</span>
      }
      @if (contactLinkObject?.isEmail) {
        <a [href]="'mailto:' + contactLinkObject?.link"> {{ contactLinkObject?.link }}</a>
      } @else {
        @if (contactLinkObject?.contactLinkText) {
          <a [href]="contactLinkObject?.link"> {{ contactLinkObject?.contactLinkText }}</a>
        }
      }
    </div>
  </div>
</ng-container>
